import * as Yup from "yup";
export const formFieldsForgetPassword = {
  resetRequest: [
    {
      name: "email",
      label: "Email Address",
      type: "email",
      placeholder: "Enter your email address",
      validation: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      icon: "email",
    },
  ],
  passwordReset: [
    {
      name: "password",
      label: "New Password",
      type: "password",
      placeholder: "Enter your new password",
      validation: Yup.string().required("Password is required"),
      icon: "password",
    },
    {
      name: "confirmPassword",
      label: "Confirm Password",
      type: "password",
      placeholder: "Confirm your new password",
      validation: Yup.string()
        .required("Please confirm your password")
        .oneOf([Yup.ref("password")], "Passwords must match"),
      icon: "password",
    },
  ],
};

const validationSchemaSignUp = Yup.object().shape({
  full_name: Yup.string()
    .required("Full name is required")
    .min(2, "Full name must be at least 2 characters")
    .max(50, "Full name must not exceed 50 characters"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
  account_type: Yup.string()
    .required("Account type is required")
    .oneOf(["HOMEOWNER", "STR_HOST", "LANDLORD", "PROPERTY_MANAGER", "VENDOR"]),
});

export const signUpFields = [
  {
    name: "full_name",
    label: "Full Name",
    type: "text",
    placeholder: "Enter your full name",
    validation: validationSchemaSignUp.fields.full_name,
    icon: "person",
    autoComplete: "name",
  },
  {
    name: "email",
    label: "Email Address",
    type: "email",
    placeholder: "Enter your email",
    validation: validationSchemaSignUp.fields.email,
    icon: "email",
    autoComplete: "email",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter your password",
    validation: validationSchemaSignUp.fields.password,
    icon: "password",
    autoComplete: "new-password",
  },
  {
    name: "account_type",
    label: "Account Type",
    type: "select",
    placeholder: "Select your account type",
    options: [
      {
        label: "Landlord",
        value: "LANDLORD",
        description: "Looking to manage properties",
      },
      {
        label: "Property Manager",
        value: "PROPERTY_MANAGER",
        description: "Professional property manager",
      },
      {
        label: "Vendor",
        value: "VENDOR",
        description: "Service professional or contractor",
      },
      {
        label: "Homeowner",
        value: "HOMEOWNER",
        description: "Owner of a residential property",
      },
      {
        label: "Short Term Rental Host",
        value: "STR_HOST",
        description: "Host of short-term rentals",
      },
    ],
    validation: validationSchemaSignUp.fields.account_type,
    icon: "account_type",
  },
];

const validationSchemaLogin = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string().required("Password is required"),
});

export const loginFields = [
  {
    name: "email",
    label: "Email Address",
    type: "email",
    placeholder: "Enter your email",
    validation: validationSchemaLogin.fields.email,
    icon: "email",
    autoComplete: "email",
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter your password",
    validation: validationSchemaLogin.fields.password,
    icon: "password",
    autoComplete: "current-password",
  },
];
